<template>
  <svg width="0.42em" height="1em" viewBox="0 0 160 384">
    <path
      d="M158 94l-98 98l98 98l-30 30L0 192L128 64z"
      fill="currentColor"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "ZmdiChevronLeft",
};
</script>
